export enum SceneKey {
  UI = 'UIScene',
  DiceOverlay = 'DiceOverlay',
  Error = 'Error',
  Finish = 'Finish',
  Game = 'Game',
  Home = 'Home',
  Preload = 'Preload',
  AdminLayout = 'AdminLayout',
  AdminPreload = 'AdminPreload',
  Reward = 'Reward',
}
